import reportActionCreators from '../actions/reportActionCreators';
import issueActionCreators from '../actions/issueActionCreators';
import formActionCreators from '../actions/formActionCreators';
import jobActionCreators from '../actions/jobActionCreators';
import store from '../reducers/storeRegistration';
const actionCreators = {
  reportActionCreators,
  issueActionCreators,
  jobActionCreators,
  formActionCreators
};

/**
 * this saves the currently active form
 */
export const evaluate = async (entity, entityName) => {
  var _currentState$entityN;
  const entityActions = actionCreators[`${entityName}ActionCreators`];
  const currentState = await store.getState();
  if (!currentState[entityName]) {
    return undefined;
  }
  if (!((_currentState$entityN = currentState[entityName]) !== null && _currentState$entityN !== void 0 && _currentState$entityN.loading)) {
    const result = await store.dispatch(entityActions.serverSave());
    return result;
  }
  return undefined;
};
export default {
  evaluate
};